import {React,useState} from 'react';
import './App.css';
import Navbar from './Navbar'

function App() {



  return (
    <div className="App">
      <Navbar></Navbar>
      <iframe src="https://eventi.4all.it/marcospiller50/" width={"100%"} style={{height:'99vh',overflowX:'hidden',border:'none'}}></iframe>
    </div>
  );
}

export default App;
